export default __webpack_public_path__ + "static/paragon-80a86ac0130e5edaada970354777dc4e.png";